import React from 'react';
import { ChevronDown, MapPin } from 'lucide-react';
import { useDeliveryLocation } from '../context/DeliveryLocationContext';
import { displayLabelFor } from '../utils/deliveryLocationLabels';
import { focusRing } from '../styles/ui';

// "Delivering to …" in the header. Shows the browsing location from
// DeliveryLocationContext — the geography the catalogue is served for — and
// opens the location dialog. Choosing a location needs no account, so guests
// are never sent to sign in from here.
const DeliveryLocation = ({ className = '' }) => {
  const { status, label, pincode, isServiceable, openLocationPrompt } = useDeliveryLocation();
  const hasLocation = status !== 'unknown';
  const text = hasLocation ? displayLabelFor({ label, pincode }) : 'Select location';
  const caption = !hasLocation ? 'Deliver to' : isServiceable === false ? 'Delivery unavailable' : 'Delivering to';

  return (
    <button
      type="button"
      onClick={openLocationPrompt}
      aria-haspopup="dialog"
      aria-label={hasLocation ? `${caption} ${text}. Change delivery location` : 'Select delivery location'}
      data-testid="delivery-location"
      className={`flex items-center gap-2 rounded-xl px-2 py-1.5 text-left hover:bg-emerald-50 transition-colors ${focusRing} ${className}`}
    >
      <span className="w-9 h-9 rounded-full bg-emerald-50 text-emerald-700 flex items-center justify-center shrink-0">
        <MapPin size={18} aria-hidden="true" />
      </span>
      <span className="min-w-0">
        <span
          className={`block text-[11px] leading-tight ${isServiceable === false ? 'text-amber-700' : 'text-ink-secondary'}`}
        >
          {caption}
        </span>
        <span className="block text-sm font-bold text-emerald-950 leading-tight truncate max-w-[10rem]">{text}</span>
      </span>
      <ChevronDown size={16} className="text-ink-secondary shrink-0" aria-hidden="true" />
    </button>
  );
};

export default DeliveryLocation;
